import { socket } from "./App";
import { RequestFactory } from "./libs/services";
import { Music, Playlist } from "./types/global.type";
import { useState, useRef } from "react";

export function Hooks() {
  const [playMusic, setPlayMusic] = useState(false);
  const [volume, setVolume] = useState(0.25);
  const [currentPlaylist, setCurrentPlaylist] = useState<Playlist | null>(null);
  const [currentMusic, setCurrentMusic] = useState<Music | null>(null);
  const [listPlaylist, setListPlaylist] = useState<Playlist[]>([]);

  function onDragEnd(result: any) {
    // dropped outside the list
    if (!result.destination || !currentPlaylist) {
      return;
    }
    const newMusics: Playlist = {
      ...currentPlaylist,
      musics: reorder(
        currentPlaylist?.musics,
        result.source.index,
        result.destination.index
      ),
    };
    setCurrentPlaylist(newMusics);
    RequestFactory.currentPlaylist.sendNewOrder(newMusics, socket.id);
  }

  // a little function to help us with reordering the result
  const reorder = (
    list: Music[],
    sourceIndex: number,
    desctinationIndex: number
  ) => {
    const result = Array.from(list);
    const [removed] = result.splice(sourceIndex, 1);
    result.splice(desctinationIndex, 0, removed);
    return result;
  };

  const audioRef = useRef<HTMLAudioElement | null>(null);
  return {
    playMusic,
    setPlayMusic,
    volume,
    setVolume,
    currentPlaylist,
    setCurrentPlaylist,
    listPlaylist,
    setListPlaylist,
    currentMusic,
    setCurrentMusic,
    audioRef,
    onDragEnd,
  };
}
